import { useNavigate } from 'react-router-dom';

export default function Page403() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center p-6">
      <div className="text-center max-w-sm w-full">

        {/* Icon card */}
        <div className="relative mx-auto w-28 h-28 mb-6">
          <div className="absolute inset-0 bg-amber-500/10 rounded-3xl rotate-6" />
          <div className="absolute inset-0 bg-amber-500/10 rounded-3xl -rotate-3" />
          <div className="relative w-full h-full bg-gray-800 rounded-3xl flex items-center justify-center border border-gray-700/60">
            <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor"
              strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" className="text-amber-400">
              <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
              <path d="M7 11V7a5 5 0 0110 0v4"/>
            </svg>
          </div>
        </div>

        {/* Code */}
        <p className="text-[96px] font-black leading-none text-amber-500/15 select-none -mb-4">403</p>

        {/* Text */}
        <h1 className="text-2xl font-bold text-white mb-2">Erişim Reddedildi</h1>
        <p className="text-gray-400 text-sm leading-relaxed mb-8">
          Bu sayfayı görüntülemek için gerekli yetkiye sahip değilsiniz.
          <br />Sistem yöneticinizle iletişime geçin.
        </p>

        {/* Actions */}
        <div className="flex flex-wrap gap-3 justify-center">
          <button
            onClick={() => navigate(-1)}
            className="px-5 py-2.5 rounded-xl bg-gray-800 hover:bg-gray-700 text-gray-300 text-sm font-medium border border-gray-700 transition-colors">
            ← Geri Dön
          </button>
          <button
            onClick={() => navigate('/')}
            className="px-5 py-2.5 rounded-xl bg-amber-600 hover:bg-amber-500 text-white text-sm font-medium transition-colors">
            Ana Sayfa
          </button>
        </div>
      </div>
    </div>
  );
}
